module.exports = __webpack_public_path__ + "static/media/IncreasingPositiveAttitude.4e85df7d.mp3";